export function datajs(name, ctx = document) {
	let elements = ctx.querySelectorAll('[data-js~="' + name + '"]');

	return elements;
}

export function datajsAll(selector, parent) {
	return Array.prototype.slice.call((parent || document).querySelectorAll('[data-js~="' + selector + '"]'));
}
